export default {
    successful_action_title: 'OK!',
    successful_action_text: 'Action successfully executed!',
    confirm_deactivate: {
        title: 'Are you sure you want to disable?',
        title_particular: 'Do you want to disable the item {{item}}?',
        title_close_chat: 'Close Chat',
        text: 'The item will be disabled and you will not be able to use it until you enable it again.',
        text_close_chat: 'When you close the chat, it will no longer be possible to interact in this chat, are you sure you want to close it?',
        text_success: 'Item {{item}} has been disabled!',
        text_success_close_chat: 'Chat closed with success!',
        button_confirm: 'Yes, disable.',
        button_close_chat: 'Yes, close chat',
    },
    confirm_delete: {
        title: 'Are you sure you want to delete?',
        title_particular: 'Do you want to delete the item {{item}}?',
        title_workload: 'Are you sure you want to delete this workload?',
        text: 'After deleting the item, you will not be able to revert this action, are you sure you want to continue?',
        text_organization: 'When deleting this Organization, the Customers and Service Groups linked to it will also be deleted. ' +
            'You will not be able to reverse this action, are you sure you want to continue?',
        text_attendance_group: 'When deleting this Service Group, it will no longer be possible to view the Tickets belonging to it.' +
            'You will not be able to reverse this action, are you sure you want to continue?',
        text_sla_config: "You are deleting the SLA configuration from the <b>'{{attendance_group_name}}'</b> service group and the <b>'{{call_category_name}}'</b> category.",
        button_confirm: 'Yes, delete.',
        text_success: 'Item {{item}} has been delete!',
        text_success_sla_config: "The SLA for the <b>'{{attendance_group_name}}'</b> service group and <b>'{{call_category_name}}'</b> category has been deleted." +
            "<br>Now the tickets linked to this service group and category no longer have SLA control.",
        title_call_spam: 'Delete and Mark Ticket as Spam',
        text_call_spam: 'After performing this action, the ticket will be <b>permanently deleted</b> from the system ' +
            'and the email that opened this ticket will be marked as SPAM so as not to open any more tickets when receiving ' +
            'emails from this sender, are you sure you want to continue',
    },
    confirm_restore: {
        title: 'Are you sure you want to restore?',
        title_particular: 'Do you want to restore the {{item}} item?',
        text: 'The item will be restored and you can use it normally',
        button_confirm: 'Yes, restore',
        text_success: 'Item {{item}} has been restored!',
    },
    confirm_warning_action: {
        title: 'Are you sure?',
        title_sla_regard: 'Do you want the SLA to be considered?',
        text_sla_regard: 'After this action the SLA will be considered again for this ticket.',
        text_taskier_document: 'A document update notification email {{document_type}} will be sent to all platform users',
        title_archive_task: 'Do you want to archive this task?',
        text_archive_task: 'After archiving the task, it will no longer be possible to update it.',
        text_success_archive_task: 'This task was archived on {{date}}. You cannot update information for this task.',
        title_archive_ticket: '¿Quieres archivar este ticket?',
        text_archive_ticket: 'Después de archivar el ticket, ya no será posible actualizarlo.',
        button_confirm: 'Yes, proceed.',
        title_unsubscribe: 'Do you want to cancel your current subscription?',
        text_unsubscribe: 'When canceling the subscription, you will return to the Free plan, and no further charges will be made to your card. ' +
            'You will still be able to enjoy the benefits of the current plan for the period already paid for. ' +
            'See the difference in plan features',
        title_success_unsubscribe: 'Subscription Cancelled!',
        text_success_unsubscribe: 'Your subscription has been successfully cancelled.',
    },
    edit_success: {
        text: 'Data updated successfully!',
        text_admin: 'Administrator updated successfully!',
        text_agent: 'User updated successfully!',
        text_agreed_load: 'Load updated successfully!',
        text_attendance_group: 'Service Group updated successfully!',
        text_attendance_type: 'Status updated successfully!',
        text_call: 'Ticket number {{number}} has been updated successfully!',
        text_call_config_email: 'Email configuration successfully updated!',
        text_category: 'Category updated successfully!',
        text_customer: 'Client updated successfully!',
        text_faq_article: 'FAQ Article updated successfully!',
        text_faq_category: 'FAQ Category updated successfully!',
        text_holiday: 'Holiday updated successfully!',
        text_organization: 'Organization updated successfully!',
        text_role: 'Access Profile updated successfully!',
        text_sla_config: 'SLA Configuration updated successfully!',
        text_workload: 'Workload updated successfully!',
        text_work_type: 'Workload Type updated successfully!',
        text_responsible_attach: 'Responsible successfully linked!',
        text_plan: 'Plan updated successfully!',
        text_task_status: 'Task Status updated successfully!',
        text_task_type: 'Task Type updated successfully!',
        text_task: 'Task number {{number}} successfully edited!',
        title_subscription: 'Subscription Updated!',
        text_subscription: 'Congratulations, your subscription has been successfully updated.',
    },
    save_success: {
        text: 'Registration successful!',
        text_admin: 'Administrator successfully registered!',
        text_agent: 'User successfully registered!',
        text_agreed_load: 'Load added successfully!',
        text_attendance_group: 'Service Group successfully registered!',
        text_attendance_type: 'Status successfully registered! {{info}}',
        text_call: 'Ticket number {{number}} has been created successfully!',
        text_call_access: 'Access ticket #{{number}}',
        text_call_config_email: 'E-mail setup successfully registered!!',
        text_category: 'Category successfully registered!',
        text_customer: 'Client successfully registered!',
        text_faq_article: 'FAQ article successfully registered!',
        text_faq_category: 'FAQ category successfully registered!',
        text_holiday: 'Holiday successfully registered!',
        text_organization: 'Organization successfully registered!',
        text_role: 'Access Profile successfully registered!',
        text_sla_config: 'SLA Configuration successfully registered!',
        text_workload: 'Workload successfully registered!',
        text_workload_started: 'Activity started successfully!',
        text_work_type: 'Workload Type successfully registered!',
        text_call_transfer: 'Tickets transferred successfully!',
        text_plan: 'Plan successfully registered!',
        text_task_status: 'Task Status successfully registered!',
        text_task_type: 'Task Type successfully registered!',
        text_task: 'Task number {{number}} successfully registered!',
        text_task_access: 'Access task #{{number}}',
        title_subscription: 'Subscription Completed!',
        text_subscription: 'Congratulations, you have changed your subscription plan to plan {{plan}}.',
        title_subscription_trial: 'Free Trial Started!',
        text_subscription_trial: 'Congratulations, you have started your free trial period. You will be able to use the benefits of plan {{plan}} until {{- trialEndAt}}',
    },
    call_response: {
        text_success: 'Reply sent successfully!',
    },
    attendance_type: {
        updated_order: 'The order entered for this Status is the last order in the list. This Status was registered with order {{newOrder}}.'
    },
    archived_ticket: {
        text_success: 'Call archived successfully!',
    },
    timezone_wrong: {
        title: "Are your account's time zone settings correct?",
        text: 'It has been identified that you are probably in the <b>{{clientTz}}</b> timezone, ' +
            'however, your account is set to <b>{{userTz}}</b>.<br><br> Do you want to be redirected to edit your account?',
        button_confirm: 'Yes, redirect',
        button_cancel: 'No, ignore warning',
    },
    service_chat: {
        text_success_agent_transfer: 'A transfer request has been sent to the user. You will be notified once the user accepts and the chat is transferred',
        text_success_cancel_transfer: 'Transfer canceled successfully.',
        button_open_ticket: 'I want to open a ticket',
    },
    remove_sla_config_from_calls: {
        title: 'Remove SLA from open tickets',
        text: 'Do you want to remove the SLA configuration from the still open tickets that have the service group and category of the configuration that is being deleted?',
        button_confirm: 'Yes, remove ticket configuration',
        button_deny: 'No, just delete this setting',
    },
    update_sla_config_from_calls: {
        title: 'Update SLA of open tickets',
        text: 'Do you want to update the SLA configuration for open tickets that have this service group and category?',
        button_confirm: 'Yes, update ticket configuration',
        button_deny: 'No, just update this setting.',
    },
    update_sla_config_from_call: {
        text: 'After updating, the SLA configuration for that ticket will be the same as the current record of the service group and category for that ticket.',
        text_success: 'The SLA configuration for this ticket has been updated according to the current record of the service group and category of the ticket.',
    },
    update_business_time_from_calls: {
        title: 'Update Open Ticket Office Hours',
        text: 'Do you want to update the office hours of tickets that have this service group?<br><br>' +
            '<b>Warning:<b> If you update the office hours of tickets, the SLA will be recalculated for those who have an SLA.',
        text_success: 'Service Group successfully updated! <br>It may take a few minutes for all open tickets to be updated with the new office hours.',
        button_confirm: 'Yes, update the tickets',
        button_deny: 'No, just update this group',
    },
    call_not_found: {
        title: 'Ticket not found',
        text: 'Ticket number {{number}} was not found, please confirm that you have entered the correct number and that you belong to the ticket service group'
    },
    tinymce_paste_image_title: 'Action not allowed',
    tinymce_paste_image_text: 'It is not possible to add an image to the message body',
    tinymce_image_upload: {
        title: 'Problem uploading images!',
        text: 'We were unable to upload one of the images within your message. Try deleting and adding it.',
    },
    workload_already_finished: {
        title: 'Activity already finished',
        text: 'This activity has already been completed, please refresh the page'
    },
    days_left_to_delete_tenant: '{{time}} it will be permanently deleted',
    corporate_plan: {
        title: 'Corporate Plan',
        text: 'Get in touch with us through our email {{- link}}',
    },
}
